var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Card/CardIconList.js",
  _this = this;
import React from 'react';
import { Layout } from '../../components';
import Spacing from '../Spacing/Spacing';
import Text from '../Text/Text';
import { IconListItem, IconListWrapper } from './style';
var CardIconList = function CardIconList(_ref) {
  var _ref$maxIconCount = _ref.maxIconCount,
    maxIconCount = _ref$maxIconCount === void 0 ? 4 : _ref$maxIconCount,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    title = _ref.title;
  var filteredItems = items.filter(function (item) {
    return Boolean(item);
  });
  var showTitle = filteredItems.length === 1;
  var iconsList = filteredItems.length > maxIconCount ? filteredItems.slice(0, maxIconCount) : filteredItems;
  return /*#__PURE__*/React.createElement(Layout.Inline, {
    "data-testid": "CardIconList",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  }, iconsList.map(function (item, key) {
    return /*#__PURE__*/React.createElement(IconListWrapper, {
      key: key,
      showTitle: showTitle,
      "data-testid": "CardIcon",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(IconListItem, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(React.Fragment, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 15
      }
    }, item)), showTitle && title ? /*#__PURE__*/React.createElement(Spacing, {
      left: 2,
      responsive: false,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 30,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(Text, {
      type: "boldBody",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 17
      }
    }, title)) : null);
  }));
};
export default CardIconList;